import { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { OptionButton } from './option-button';
import { Label } from './label';
import { Fieldset } from './fieldset';

type DecisionButtonsProps = {
  label: ReactNode;
  selected?: 'yes' | 'no';
  onSelection: (value: 'yes' | 'no') => void;
  align?: 'center' | 'left';
  disabled?: boolean;
  helper?: {
    text: string;
    link: string;
  };
  className?: string;
};

export function DecisionButtons(props: DecisionButtonsProps) {
  const { label, selected, onSelection, align = 'center', helper, disabled, className } = props;

  const { t } = useTranslation();

  return (
    <Fieldset className={className}>
      <Label className={align === 'center' ? 'text-center justify-center' : 'text-left'}>
        {label}
        {helper ? (
          <a
            href={helper.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary underline"
          >
            {helper.text}
          </a>
        ) : null}
      </Label>
      <div className={`flex gap-2 ${align === 'center' ? 'justify-center' : 'justify-start'}`}>
        <OptionButton
          value="no"
          active={selected === 'no'}
          onClick={() => onSelection('no')}
          disabled={disabled}
        >
          {t('no')}
        </OptionButton>
        <OptionButton
          value="yes"
          active={selected === 'yes'}
          onClick={() => onSelection('yes')}
          disabled={disabled}
        >
          {t('yes')}
        </OptionButton>
      </div>
    </Fieldset>
  );
}
